import { CreateAvatarScreen } from '@/screens/name-screen/CreateAvatarScreen'

export default function () {
  return <CreateAvatarScreen />
}
